import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useImperativeHandle } from "react";
import { FluentProvider, Toast, Toaster, ToastTitle, useFluent, useId, useToastController } from "@fluentui/react-components";
const ToastContext = createContext({ showToast: () => { } });
/**
 * Provides toast notification functionality to child components via context and an optional imperative ref.
 * @returns The toast provider component tree.
 */
export const ToastProvider = ({ children, imperativeRef }) => {
    const toasterId = useId("toaster");
    const { dispatchToast } = useToastController(toasterId);
    const { targetDocument } = useFluent();
    const showToast = useCallback((message, options) => {
        dispatchToast(_jsx(Toast, { children: _jsx(ToastTitle, { children: message }) }), { intent: options?.intent ?? "info", timeout: 2000 });
    }, [dispatchToast]);
    useImperativeHandle(imperativeRef, () => ({ showToast }), [showToast]);
    return (_jsxs(ToastContext.Provider, { value: { showToast }, children: [children, _jsx(FluentProvider, { applyStylesToPortals: true, targetDocument: targetDocument, children: _jsx(Toaster, { toasterId: toasterId, position: "bottom" }) })] }));
};
/**
 * Hook to show toast notifications.
 * @returns Object with showToast function that accepts a message string
 */
export function useToast() {
    return useContext(ToastContext);
}
//# sourceMappingURL=toast.js.map